export const errorMessage = (code) => {
  switch (code) {
    case "5":
      return "Transação não autorizada, verifique e tente novamente.";

    case "57":
      return "Cartão expirado. Tente novamente com outro cartão.";

    case "78":
      return "Cartão bloqueado, verifique e tente novamente.";

    case "99":
      return "Problemas com seu cartão. Verifique e tente novamente.";

    case "77":
      return "Cartão cancelado. Tente novamente com outro cartão.";

    case "70":
      return "Problemas com seu cartão. Entre em contato com a operadora.";

    case "0":
    case "11":
      return "Transação efetuada com sucesso!";

    case "2":
    case "60":
    case "85":
    case "90":
    case "AF":
    case "AG":
    case "BD":
    case "79":
    case "82":
    case "83":
    case "BP":
    case "DM":
    case "DS":
    case "EK":
    case "FC":
      return "Transação não autorizada. Entre em contato com seu banco ou tente novamente com outro cartão.";

    case "67":
    case "BN":
      return "Cartão ou conta bloqueada. Entre em contato com seu banco ou tente novamente com outro cartão.";

    case "FF":
      return "Cancelamento efetuado com sucesso!";

    case "9":
      return "Transação parcialmente cancelada. Qualquer dúvida, entre em contato com seu banco emissor.";

    case "21":
      return "Não foi possível processar o cancelamento da compra. Faça o pedido novamente. Se o erro persistir, fale com a gente.";

    case "89":
      return "Erro na transação. Tente novamente e, se o erro persistir, entre em contato com seu banco emissor.";

    case "999":
    case "98":
      return "No momento, não foi possível concluir sua compra. Tente novamente mais tarde.";

    case "AA":
    case "BL":
      return "Não foi possível concluir sua compra. Tente novamente e, se o erro persistir, entre em contato com seu banco.";

    case "AH":
      return "Transação não autorizada. Os dados informados são inválidos para a opção de pagamento selecionada. Tente novamente.";

    case "NR":
      return "Transação não permitida. Tente novamente após 30 dias.";

    case "RP":
      return "Transação não permitida. Tente novamente após 72 horas.";

    case "475":
      return "Não conseguimos concluir a sua compra. Tente novamente e, se o erro persistir, entre em contato com o suporte.";

    case "97":
      return "Transação não autorizada. Valor não permitido para essa transação. Tente novamente com outro cartão.";

    case "80":
    case "AV":
    case "24":
    case "AI":
    case "C2":
    case "DF":
    case "FE":
    case "UE":
    case "6P":
      return "Transação não autorizada. Tente novamente e, antes de concluir, confirme os dados informados.";

    case "BR":
      return "Transação não autorizada. Sua conta foi encerrada. Entre em contato com seu banco para mais detalhes.";

    case "DQ":
    case "CG":
    case "CF":
    case "KE":
      return "Falha na validação dos dados informados. Tente novamente ou entre em contato com seu banco.";

    case "EB":
      return "Transação não autorizada. Entre em contato com a Cielo e verifique se o cadastro possui parcelamento liberado.";

    case "EE":
      return "Transação não permitida. O valor da parcela está abaixo do mínimo permitido. Qualquer dúvida, fale com a gente.";

    case "FG":
      return "Transação não autorizada. Entre em contato com a Central de Atendimento AmEx no 0800 728 5090.";

    case "GF":
    case "GD":
    case "GT":
    case "GK":
      return "Transação não permitida. Entre em contato com a Cielo.";

    case "HJ":
    case "IA":
    case "KA":
      return "Transação não permitida. Entre em contato com a gente.";

    case "KB":
      return "Transação não permitida. A opção selecionada está incorreta. Tente novamente e, antes de concluir, confirme os dados informados.";

    default:
      return "No momento, não foi possível concluir sua compra. Tente novamente mais tarde.";
  }
};
